import { t } from 'i18n';

const i18nOpts = { scope: 'care_plan_creators.check_in_templates.questions.likert_presets' };

const presets = [
  {
    name: 'frequency',
    label: t('frequency.label', i18nOpts),
    responseOptions: [
      t('frequency.response_options.never', i18nOpts),
      t('frequency.response_options.rarely', i18nOpts),
      t('frequency.response_options.sometimes', i18nOpts),
      t('frequency.response_options.often', i18nOpts),
      t('frequency.response_options.always', i18nOpts),
    ],
  },
  {
    name: 'frequency_per_week',
    label: t('frequency_per_week.label', i18nOpts),
    responseOptions: [
      t('frequency_per_week.response_options.times_0', i18nOpts),
      t('frequency_per_week.response_options.times_1_2', i18nOpts),
      t('frequency_per_week.response_options.times_3_4', i18nOpts),
      t('frequency_per_week.response_options.times_5_6', i18nOpts),
      t('frequency_per_week.response_options.every_day', i18nOpts),
    ],
  },
  {
    name: 'level_of_agreement',
    label: t('level_of_agreement.label', i18nOpts),
    responseOptions: [
      t('level_of_agreement.response_options.strongly_disagree', i18nOpts),
      t('level_of_agreement.response_options.disagree', i18nOpts),
      t('level_of_agreement.response_options.neutral', i18nOpts),
      t('level_of_agreement.response_options.agree', i18nOpts),
      t('level_of_agreement.response_options.strongly_agree', i18nOpts),
    ],
  },
  {
    name: 'level_of_clarity',
    label: t('level_of_clarity.label', i18nOpts),
    responseOptions: [
      t('level_of_clarity.response_options.not_clear', i18nOpts),
      t('level_of_clarity.response_options.slightly_clear', i18nOpts),
      t('level_of_clarity.response_options.somewhat_clear', i18nOpts),
      t('level_of_clarity.response_options.very_clear', i18nOpts),
      t('level_of_clarity.response_options.extremely_clear', i18nOpts),
    ],
  },
  {
    name: 'level_of_confidence',
    label: t('level_of_confidence.label', i18nOpts),
    responseOptions: [
      t('level_of_confidence.response_options.not_confident', i18nOpts),
      t('level_of_confidence.response_options.slightly_confident', i18nOpts),
      t('level_of_confidence.response_options.somewhat_confident', i18nOpts),
      t('level_of_confidence.response_options.very_confident', i18nOpts),
      t('level_of_confidence.response_options.completely_confident', i18nOpts),
    ],
  },
  {
    name: 'level_of_difficulty',
    label: t('level_of_difficulty.label', i18nOpts),
    responseOptions: [
      t('level_of_difficulty.response_options.very_easy', i18nOpts),
      t('level_of_difficulty.response_options.easy', i18nOpts),
      t('level_of_difficulty.response_options.neutral', i18nOpts),
      t('level_of_difficulty.response_options.difficult', i18nOpts),
      t('level_of_difficulty.response_options.very_difficult', i18nOpts),
    ],
  },
  {
    name: 'level_of_importance',
    label: t('level_of_importance.label', i18nOpts),
    responseOptions: [
      t('level_of_importance.response_options.not_important', i18nOpts),
      t('level_of_importance.response_options.slightly_important', i18nOpts),
      t('level_of_importance.response_options.moderately_important', i18nOpts),
      t('level_of_importance.response_options.important', i18nOpts),
      t('level_of_importance.response_options.very_important', i18nOpts),
    ],
  },
  {
    name: 'level_of_likelihood',
    label: t('level_of_likelihood.label', i18nOpts),
    responseOptions: [
      t('level_of_likelihood.response_options.very_unlikely', i18nOpts),
      t('level_of_likelihood.response_options.unlikely', i18nOpts),
      t('level_of_likelihood.response_options.neutral', i18nOpts),
      t('level_of_likelihood.response_options.likely', i18nOpts),
      t('level_of_likelihood.response_options.very_likely', i18nOpts),
    ],
  },
  {
    name: 'level_of_quality',
    label: t('level_of_quality.label', i18nOpts),
    responseOptions: [
      t('level_of_quality.response_options.poor', i18nOpts),
      t('level_of_quality.response_options.fair', i18nOpts),
      t('level_of_quality.response_options.good', i18nOpts),
      t('level_of_quality.response_options.very_good', i18nOpts),
      t('level_of_quality.response_options.excellent', i18nOpts),
    ],
  },
  {
    name: 'level_of_understanding',
    label: t('level_of_understanding.label', i18nOpts),
    responseOptions: [
      t('level_of_understanding.response_options.do_not_understand', i18nOpts),
      t('level_of_understanding.response_options.barely_understand', i18nOpts),
      t('level_of_understanding.response_options.partly_understand', i18nOpts),
      t('level_of_understanding.response_options.mostly_understand', i18nOpts),
      t('level_of_understanding.response_options.fully_understand', i18nOpts),
    ],
  },
  {
    name: 'number_of_times',
    label: t('number_of_times.label', i18nOpts),
    responseOptions: [
      t('number_of_times.response_options.times_0', i18nOpts),
      t('number_of_times.response_options.times_1_3', i18nOpts),
      t('number_of_times.response_options.times_4_6', i18nOpts),
      t('number_of_times.response_options.times_7_9', i18nOpts),
      t('number_of_times.response_options.times_10', i18nOpts),
    ],
  },
  {
    name: 'percentage_rating',
    label: t('percentage_rating.label', i18nOpts),
    responseOptions: [
      t('percentage_rating.response_options.percent_0_20', i18nOpts),
      t('percentage_rating.response_options.percent_21_40', i18nOpts),
      t('percentage_rating.response_options.percent_41_60', i18nOpts),
      t('percentage_rating.response_options.percent_61_80', i18nOpts),
      t('percentage_rating.response_options.percent_81_100', i18nOpts),
    ],
  },
];

export default presets;
